// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6bfe7826","453":"3f32cd84","455":"d7eb7019","977":"a89206e5"}[chunkId] + ".chunk.js";
};